import React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@v2/lib';
import { PermissionsProvider } from './PermissionsContext';

export const AppContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <PermissionsProvider>{children}</PermissionsProvider>
    </QueryClientProvider>
  );
};

export default AppContextProvider;
